<!--
 * @Author: wjc
 * @Date: 2023-11-08 16:13:03
 * @LastEditors: LiZhiWei
 * @LastEditTime: 2025-02-07 10:04:09
 * @Description: 
-->
<template>
  <div
    class="flex justify-between my-24px h-120px md:overflow-hidden md:flex-row lt-xs:flex-col lt-xs:h-auto"
  >
    <div class="h-full mr-16px md:w-240px md:mb-0px xs:w-full lt-xs:mb-16px lt-xs:mr-0px">
      <el-space direction="vertical" class="services-col-main py-28px color-white wh-full">
        <div class="font-s-2.8rem font-600 sm:font-s-2rem">综合服务</div>
        <!-- <div class="i-custom-fwqd wh-48px"></div> -->
        <div class="font-s-1.1rem">最新更新时间</div>
        <div class="font-s-2.4rem font-600 sm:font-s-1.1rem">
          {{ data.pushTime || '--' }}
        </div>
      </el-space>
    </div>
    <el-row class="lt-xs:h-118px w-full lt-md:overflow-y-auto lt-md:overflow-x-hidden">
      <el-col :span="24">
        <el-row
          class="h-full flex-grow overflow-y-auto"
          :gutter="$screen.higherThan('sm') ? 0 : 16"
        >
          <el-col
            v-for="item in colData"
            :key="item.text"
            :lg="6"
            :md="12"
            :sm="12"
            :xs="24"
            class="mb-16px"
          >
            <div class="h-full bg-bg-2 p-16px rounded-4px h-120px">
              <div class="font-s-18px font-600 text-color-1 mb-16px text-left">{{ item.text }}</div>
              <div class="flex justify-between items-center">
                <span :class="item.icon" class="wh-38px"></span>
                <span
                  class="text-color-1 font-s-14px px-12px py-6px rounded-24px border-1px border-solid border-primary-color"
                >
                  <MLink :to="item.link" class="text-primary-color">点击进入</MLink>
                </span>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-col>
      <!-- <el-col :span="24">
        <el-row
          class="h-full flex-grow overflow-y-auto"
          :gutter="$screen.higherThan('sm') ? 0 : 16"
        >
          <el-col
            v-for="item in colData2"
            :key="item.text"
            :lg="6"
            :md="12"
            :sm="12"
            :xs="24"
            class="lt-md:mb-16px"
          >
            <div class="h-full bg-bg-2 p-16px rounded-4px h-110px">
              <div class="font-s-18px font-600 text-color-1 mb-16px text-left">{{ item.text }}</div>
              <div class="flex justify-between items-center">
                <span :class="item.icon" class="wh-38px"></span>
                <span
                  class="text-color-1 font-s-14px px-12px py-6px rounded-24px border-1px border-solid border-primary-color"
                >
                  <MLink :to="item.link" class="text-primary-color">点击进入</MLink>
                </span>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-col> -->
    </el-row>
  </div>
</template>

<script setup lang="ts">
  import { getInfoList } from '~/api/activity/info'
  import type { IInfo } from '~/models/activity'

  const $screen = useScreen()
  const span = computed(() => $screen.span.value)
  const data = ref<IInfo>({
    pushTime: '',
  })
  const colData = ref([
    {
      text: '法律咨询',
      icon: 'i-custom-dd',
      link: '/content/912305321901290501',
    },
    {
      text: '承接查验',
      icon: 'i-custom-ggzx',
      link: '/content/912305321901290502',
    },
    {
      text: '物业师咨询',
      icon: 'i-custom-dd2',
      link: '/content/912305321901290503',
    },
    {
      text: '消防培训',
      icon: 'i-custom-lvh',
      link: '/content/912305321901290504',
    },
  ])
  //   const colData2 = ref([
  //     {
  //       text: '公用设施',
  //       icon: 'i-custom-gy',
  //       link: '/content/912305321901290303',
  //     },
  //     {
  //       text: '环境维护',
  //       icon: 'i-custom-huanj',
  //       link: '/content/912305321901290306',
  //     },
  //     {
  //       text: '装饰装修',
  //       icon: 'i-custom-zszx',
  //       link: '/content/912305321901290304',
  //     },
  //     {
  //       text: '案例展示',
  //       icon: 'i-custom-anl',
  //       link: '/content/912305321901290308',
  //     },
  //   ])

  getInfoList({
    pageNum: 1,
    pageSize: 1,
    isPage: true,
    classId1: '912305321901290300',
    pushTimeAtSort: 'desc',
  }).then((res) => {
    if (res.data && res.data.list) {
      if (res.data.list[0]) {
        data.value = res.data.list[0]
      }
    }
  })
</script>

<style scoped lang="scss">
  .services-col-main {
    @apply rounded-4px;
    background: linear-gradient(135deg, #5eaafe 0%, var(--primary-color) 100%);
  }
</style>
